// الكود الكامل مع زر تعديل الطلب + البوب أب المدمج والمحدث بشكل كامل حسب طلبك

import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Button,
  Link,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
   Stack, 
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "./firebase"; // إذا عندك storage.js، غير المسار حسب مشروعك
import { addDoc, collection as firestoreCollection } from "firebase/firestore";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useNavigate } from "react-router-dom";

import { db } from "./firebase";
import {
  collection,
  query,
  where,
  getDocs,
  Timestamp,
} from "firebase/firestore";
import { getDisplayStatus, getDisplayName } from "./utils/statusLabels";
import { apiFetch } from "./utils/apiClient";
import UploadPreview, { appendPickedFiles } from "./components/UploadPreview";
import { showBuiltIn } from "./utils/accountBuiltIns";
import PrintChoiceBadge from "./components/PrintChoiceBadge";

const API_BASE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000/api"
    : "https://artikaorder-backend.onrender.com/api";

const SaraDashboard = () => {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("all");
  const [editingOrder, setEditingOrder] = useState(null);
  const [editName, setEditName] = useState("");
  const [editPrice, setEditPrice] = useState("");
  const [editNote, setEditNote] = useState("");
const [loading, setLoading] = useState(false);
const [savingFeedback, setSavingFeedback] = useState(false);
const [isEditingFeedback, setIsEditingFeedback] = useState(false);
const [existingFeedbackImages, setExistingFeedbackImages] = useState([]);

  const [feedbackOpen, setFeedbackOpen] = useState(false);
const [feedbackText, setFeedbackText] = useState("");
const [feedbackImages, setFeedbackImages] = useState([]);
const [currentFeedbackOrder, setCurrentFeedbackOrder] = useState(null);
const [openFeedbackDialog, setOpenFeedbackDialog] = useState(false);
const [feedbackType, setFeedbackType] = useState(""); // ✅ جديد
const [feedbackNote, setFeedbackNote] = useState("");
const [feedbackImage, setFeedbackImage] = useState(null);
const [selectedStatus, setSelectedStatus] = useState("الكل");
const [tasksOpen, setTasksOpen] = useState(false);
const [myTasks, setMyTasks] = useState([]);
const navigate = useNavigate();
// 🆕 رفع صور التركيب
const [installationFiles, setInstallationFiles] = useState([]);
const [openInstallationDialog, setOpenInstallationDialog] = useState(false);
const [currentInstallationOrder, setCurrentInstallationOrder] = useState(null);
const [uploadingInstallation, setUploadingInstallation] = useState(false);
const [previewFile, setPreviewFile] = useState(null);
const q = query(collection(db, "tasks"), where("employee", "==", "ساره"));


  useEffect(() => {
    fetchOrders();
  }, []);


  const fetchOrders = async () => {
    const q = query(collection(db, "orders"), where("employee", "==", "ساره"));
    const snapshot = await getDocs(q);
    const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    const sorted = data.sort(
      (a, b) => b.createdAt?.seconds - a.createdAt?.seconds
    );
    setOrders(sorted);
  };

  const handleOpenEdit = (order) => {
    setEditingOrder(order);
    setEditName(order.customerName);
    setEditPrice(order.price);
    setEditNote(order.note || "");
  };

const handleUpdate = async () => {
  if (!editingOrder) return;

  const res = await apiFetch(
    `${API_BASE}/orders/${editingOrder.id}/edit-and-return`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customerName: editName,
        price: Number(editPrice),
        note: editNote,
        withDrawing: editingOrder.withDrawing,
        governorate: editingOrder.governorate,
      }),
    }
  );

  if (!res.ok) {
    console.error("خطأ أثناء تعديل الطلب:", await res.text().catch(() => ""));
    setEditingOrder(null);
    return;
  }

  setEditingOrder(null);
  fetchOrders();
};

 // ✅ فلترة حسب الحالة المختارة
  const filteredOrders = orders.filter((order) => {
    if (selectedStatus !== "الكل") {
      switch (selectedStatus) {
        case "عند يوسف":
          if (order.status !== "عند يوسف") return false;
          break;
        case "رسم":
          if (!order.status.includes("رسم")) return false;
          break;
        case "عند برهان":
          if (order.status !== "عند برهان") return false;
          break;
        case "فيدباك":
          if (order.status !== "feedbackRequired") return false;
          break;
        case "تم التوصيل":
          if (
            ![
              "تم التوصيل",
              "تركيب",
              "تم التركيب",
              "تم التوصيل (بعد الفيدباك)",
              "تم التركيب (بعد الفيدباك)",
            ].includes(order.status)
          )
            return false;
          break;
        default:
          break;
      }
    }
    return true;
  });
  const ordersToDisplay = filteredOrders.filter((order) => {
  if (filter === "inProgress") {
  return !["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status);
}
if (filter === "completed") {
  return ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status);
}

    return true;
  });

  const totalOrders = filteredOrders.length;
 const inProgressOrders = filteredOrders.filter(
  (o) => !["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(o.status)
);

const completedOrders = filteredOrders.filter((o) =>
  ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(o.status)
);

  const totalInProgress = inProgressOrders.length;
  const totalCompleted = completedOrders.length;

  const totalPrice = filteredOrders.reduce(
    (sum, o) => sum + (parseFloat(o.price) || 0),
    0
  );
  const priceInProgress = inProgressOrders.reduce(
    (sum, o) => sum + (parseFloat(o.price) || 0),
    0
  );
  const priceCompleted = completedOrders.reduce(
    (sum, o) => sum + (parseFloat(o.price) || 0),
    0
  );

  const monthlyStats = {};
  orders.forEach((order) => {
    const date = order.createdAt?.toDate();
    if (date) {
      const key = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}`;
      if (!monthlyStats[key]) {
        monthlyStats[key] = { count: 0, total: 0 };
      }
      monthlyStats[key].count += 1;
      monthlyStats[key].total += parseFloat(order.price) || 0;
    }
  });

  const monthlyArray = Object.entries(monthlyStats).sort(([a], [b]) =>
    b.localeCompare(a)
  );

  
const handleUploadInstallation = async () => {
  if (!currentInstallationOrder || installationFiles.length === 0) return;

  try {
    setUploadingInstallation(true); // 🔵 شغّل التحميل

    const uploadedFiles = [];

    for (const file of installationFiles) {
      const fileRef = ref(
        storage,
        `installation/${currentInstallationOrder.id}/${Date.now()}-${file.name}`
      );

      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);

      uploadedFiles.push({
        url,
        type: file.type.startsWith("video") ? "video" : "image",
        name: file.name,
      });
    }

   const res = await apiFetch(
  `${API_BASE}/orders/${currentInstallationOrder.id}/install`,
  {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ mode: "uploadFiles", installationFiles: uploadedFiles }),
  }
);
if (!res.ok) throw new Error(await res.text().catch(() => ""));


    setOpenInstallationDialog(false);
    setInstallationFiles([]);
    setCurrentInstallationOrder(null);
    fetchOrders();
  } catch (error) {
    console.error("❌ خطأ أثناء رفع صور التركيب:", error);
    alert("حدث خطأ أثناء رفع الملفات");
  } finally {
    setUploadingInstallation(false); // 🔵 وقف التحميل
  }
};



const handleSubmitFeedback = async () => {
  if (!currentFeedbackOrder) return;

  try {
    setSavingFeedback(true);

    const newImagesUrls = [];

    for (const file of feedbackImages) {
      const fileRef = ref(
        storage,
        `feedbackImages/${currentFeedbackOrder.id}/${Date.now()}-${file.name}`
      );
      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);
      newImagesUrls.push(url);
    }

    const finalImages = [
      ...existingFeedbackImages,
      ...newImagesUrls,
    ];

    const updateData = {
      feedback: {
        type: feedbackType,
        note: feedbackNote,
        images: finalImages,
      },
    };

    if (!isEditingFeedback) {
      updateData.feedbackRequired = false;

      let finalStatus = "تم التوصيل";
      let historyStatus = "تم التوصيل (بعد الفيدباك)";

      if (currentFeedbackOrder.completedSteps?.includes("تركيب")) {
        finalStatus = "تم التركيب";
        historyStatus = "تم التركيب (بعد الفيدباك)";
      }

      updateData.status = finalStatus;
      updateData.history = [
        ...(currentFeedbackOrder.history || []),
        {
          by: "ساره", // ⬅️ هذا فقط يتغيّر
          status: historyStatus,
          timestamp: Timestamp.now(),
        },
      ];
    }

    const feedbackRes = await apiFetch(
      `${API_BASE}/orders/${currentFeedbackOrder.id}/feedback`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...updateData, archive: false }),
      }
    );

    if (!feedbackRes.ok) {
      const errData = await feedbackRes.json().catch(() => ({}));
      throw new Error(errData.error || "حدث خطأ أثناء حفظ الفيدباك");
    }

    setExistingFeedbackImages([]);
    setFeedbackImages([]);
    setIsEditingFeedback(false);
    setOpenFeedbackDialog(false);
    setCurrentFeedbackOrder(null);

    fetchOrders();
  } catch (err) {
    console.error("خطأ تعديل الفيدباك:", err);
  } finally {
    setSavingFeedback(false);
  }
};

// ✅ دالة لإعادة تسمية الحالات
const renameStatus = (status, order) => {
  if (!status) return "";

  return getDisplayStatus(status, order).replace("feedbackRequired", "📩 فيدباك");
};
  // 📌 الحالات الممكنة للفلتر
  const uniqueStatuses = [
    "الكل",
    "عند يوسف",
    "رسم",
    "عند برهان",
    "فيدباك",
    "تم التوصيل",
  ];

  return (
    <Container sx={{ mt: 4 }} dir="rtl">
      <Typography variant="h4" align="right" fontWeight={600} sx={{ mb: 3 }}>
        لوحة ساره
      </Typography>
<Box display="flex" flexWrap="wrap" gap={2} mb={3}>
 {showBuiltIn("box:myTasks") && (
 <Button
  variant="contained"
  color="secondary"
  onClick={() => navigate("/SaraTasks")}
>
  📋 مهامي
</Button>
 )}
  {showBuiltIn("box:todo") && (
  <Button variant="outlined" onClick={() => navigate("/todo")}>
    TO-DO LIST 📋
  </Button>
  )}
   {showBuiltIn("box:ordersAdmin") && (
   <Button
  variant="contained"
  color="primary"
  onClick={() => window.open("https://admin-artika.netlify.app/login", "_blank")}
  sx={{ borderRadius: 2, fontWeight: 700 }}
>
  ادارة الطلبات
</Button>
   )}
{showBuiltIn("box:canvasCost") && (
<Button
  variant="contained"
  color="secondary"
  onClick={() => navigate("/canvas-cost")}
>
سعر اللوحة</Button>
)}
{showBuiltIn("box:leaveRequest") && (
<Button
  variant="contained"
  color="info"
onClick={() => navigate("/leave-request?u=sara@123&returnTo=/sara")}
>
   طلب إجازة
</Button>
)}

</Box>



{/* 🎯 Target Reach Progress */}
{/* 🎯 Target Reach Progress (شهري) */}
{/* 🎯 Target Reach (شهري) */}
{/* 🎯 Target Reach صغير */}
<Box
  sx={{
    display: "flex",
    justifyContent: "flex-start", // أو center إذا تريده بالوسط
    mb: 2,
  }}
>
  <Paper
    sx={{
      p: 2,
      width: 160,
      borderRadius: 3,
      boxShadow: 3,
      textAlign: "center",
    }}
  >
    {(() => {
      const now = new Date();
      const currentMonth = now.getMonth(); // 0-11
      const currentYear = now.getFullYear();

      const monthlyOrders = orders.filter((o) => {
        const date = o.createdAt?.toDate();
        return (
          date &&
          date.getMonth() === currentMonth &&
          date.getFullYear() === currentYear
        );
      });

      const totalSales = monthlyOrders.reduce(
        (sum, o) => sum + (parseFloat(o.price) || 0),
        0
      );

      const target = 30000000;
      const percentage = Math.min((totalSales / target) * 100, 100);

      return (
        <>
          <Box sx={{ width: 100, height: 100, mx: "auto" }}>
            <CircularProgressbar
              value={percentage}
              text={`${Math.round(percentage)}%`}
              styles={buildStyles({
                textColor: "#1976d2",
                pathColor: "#1976d2",
                trailColor: "#eee",
              })}
            />
          </Box>
          <Typography
            variant="body2"
            sx={{ mt: 1, fontWeight: "bold", fontSize: "0.8rem" }}
          >
            💰 {totalSales.toLocaleString()} د.ع
          </Typography>
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ fontSize: "0.7rem" }}
          >
            🎯 {target.toLocaleString()} د.ع
          </Typography>
          <Typography variant="caption" color="textSecondary">
            (شهر {currentMonth + 1})
          </Typography>
        </>
      );
    })()}
  </Paper>
</Box>

 
    <Grid container spacing={2} mb={3} dir="rtl">
  <Grid item xs={12} sm={3}>
    <TextField
      select
      label="الحالة"
      fullWidth
      value={selectedStatus}
      onChange={(e) => setSelectedStatus(e.target.value)}
      SelectProps={{ native: true }}
    >
      {uniqueStatuses.map((s, i) => (
        <option key={i} value={s}>
          {getDisplayStatus(s)}
        </option>
      ))}
    </TextField>
  </Grid>
</Grid>


      {/* عرض الطلبات */}
      {ordersToDisplay.map((order) => {
        const createdAt = order.createdAt?.toDate();
        const now = new Date();
        const diffMs = now - createdAt;
        const diffHours = diffMs / (1000 * 60 * 60);
        return (
          <Accordion key={order.id} sx={{ mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
           <Typography sx={{ fontWeight: "bold", fontSize: "0.9rem", width: "100%" }}>
  الاسم: {order.customerName} | الحالة:{" "}
{order.status === "عند برهان" && order.completedSteps?.length > 0
  ? renameStatus(`عند برهان - ${order.completedSteps[order.completedSteps.length - 1]}`)
  : renameStatus(order.status, order)}
<PrintChoiceBadge order={order} />

  {order.drawingStatus && ` | 🎨 حالة الرسم: ${order.drawingStatus}`} 
  | المحافظة: {order.governorate} | السعر: {Number(order.price).toLocaleString()} د.ع
  | 🧩 عدد اللوحات: {order.boardsCount || "—"}
  {order.withDrawing && (
    <> | 🎨 عدد لوحات الرسم: {order.drawingBoardsCount || "—"}</>
  )}

</Typography>


            </AccordionSummary>
            <AccordionDetails>
              <Typography gutterBottom>
                الرابط: <Link href={order.https} target="_blank">فتح</Link>
              </Typography>
              {order.note && <Typography gutterBottom>الملاحظات: {order.note}</Typography>}
              {order.source && <Typography gutterBottom>مصدر الطلب: {order.source}</Typography>}
{/* 🎥 عرض الفيديوهات المرفوعة من حليمة */}
{order.videoLinks && order.videoLinks.length > 0 ? (
  <Box sx={{ mt: 1 }}>
    <Typography gutterBottom sx={{ fontWeight: "bold" }}>
      🎥 فيديوهات الرسم ({order.videoLinks.length})
    </Typography>
    {order.videoLinks.map((url, index) => (
      <Box key={index} sx={{ mb: 1 }}>
        <Link href={url} target="_blank" rel="noopener">
          ▶️ مشاهدة الفيديو {index + 1}
        </Link>
      </Box>
    ))}
  </Box>
) : order.driveLink ? (
  <Typography gutterBottom>
    🎥 رابط الرسم:{" "}
    <Link href={order.driveLink} target="_blank" rel="noopener">
      فتح الرابط
    </Link>
  </Typography>
) : null}
{/* 🖼️ عرض صور التركيب */}
{order.installationFiles && order.installationFiles.length > 0 && (
  <Box mt={2}>
    <Typography fontWeight="bold">📷 صور / فيديوهات التركيب:</Typography>

    <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
      {order.installationFiles.map((f, i) =>
        f.type === "image" ? (
          <Box
            key={i}
            sx={{
              cursor: "pointer",
              border: "1px solid #ccc",
              borderRadius: 2,
              overflow: "hidden",
              width: 100,
              height: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              "&:hover": { opacity: 0.8 },
            }}
            onClick={() => setPreviewFile(f)}
          >
            <img
              src={f.url}
              alt="installation"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ) : (
          <Button
            key={i}
            variant="outlined"
            size="small"
            onClick={() => window.open(f.url, "_blank")}
          >
            🎥 فيديو {i + 1}
          </Button>
        )
      )}
    </Box>
  </Box>
)}


{order.status === "feedbackRequired" && (() => {
 const lastFeedbackStep =
  order.history?.find(h => h.status === "feedbackRequired") || {
    timestamp: order.startTime || order.createdAt,
  };


const feedbackTime = lastFeedbackStep?.timestamp?.toDate?.() || null;
  const now = new Date();

  // تحقق من مرور 24 ساعة

const canShowFeedback =
  feedbackTime && now - feedbackTime >= 24 * 60 * 60 * 1000;

console.log("🕓 feedbackTime:", feedbackTime?.toLocaleString());
console.log("🕓 now:", now.toLocaleString());
console.log("⏱ الفرق بالساعات:", (now - feedbackTime) / (1000 * 60 * 60));


  return canShowFeedback ? (
   <Button
    variant="contained"
    color="secondary"
    sx={{ mt: 2 }}
    onClick={() => {
      setCurrentFeedbackOrder(order);
      setFeedbackType(order.feedback?.type || "");
      setFeedbackNote(order.feedback?.note || "");
      setFeedbackImages([]);
      setExistingFeedbackImages(order.feedback?.images || []);
      setIsEditingFeedback(!!order.feedback);
      setOpenFeedbackDialog(true);
    }}
  >
    📩 فيدباك الزبون
  </Button>
  ) : null;
})()}


              {diffHours <= 1 && (
                <Button variant="outlined" sx={{ mt: 2 }} onClick={() => handleOpenEdit(order)}>
                  ✏️ تعديل الطلب
                </Button>
              )}
                {/* 📷 زر رفع صور التركيب */}
              {(
                order.status === "تركيب" ||
                order.status === "بانتظار تصوير التركيب" ||
                order.status?.includes("تركيب")
              ) && (
                <Box mt={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setCurrentInstallationOrder(order);
                      setInstallationFiles([]);
                      setOpenInstallationDialog(true);
                    }}
                  >
                    📷 رفع صور التركيب
                  </Button>
                </Box>
              )}
              
              <Divider sx={{ my: 2 }} />
              <Typography gutterBottom>سجل الحالة:</Typography>

              {/* فيدباك الزبون (إذا كان موجود) */}
{order.feedback && (
  <Box mt={2}>
    <Typography variant="h6" color="primary">
      📩 فيدباك الزبون:
    </Typography>

    <Typography>
      النوع: <strong>{order.feedback.type}</strong>
    </Typography>

    <Typography>
      الملاحظة: {order.feedback.note}
    </Typography>

  

    {/* 🖼️🖼️ عرض الصور المتعددة */}
    {order.feedback.images && order.feedback.images.length > 0 && (
      <Box mt={2}>
        <Typography fontWeight="bold">
          📷 صور الفيدباك ({order.feedback.images.length})
        </Typography>

        <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
          {order.feedback.images.map((url, index) => (
            <Box
              key={index}
              sx={{
                cursor: "pointer",
                border: "1px solid #ccc",
                borderRadius: 2,
                overflow: "hidden",
                width: 100,
                height: 100,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f5f5f5",
                "&:hover": { opacity: 0.8 },
              }}
              onClick={() =>
                setPreviewFile({ url })
              }
            >
              <img
                src={url}
                alt={`feedback-${index}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}
        </Box>
          <Button
                  variant="outlined"
                  size="small"
                  sx={{ mt: 2 }}
                  onClick={() => {
                    setCurrentFeedbackOrder(order);
                    setFeedbackType(order.feedback.type);
                    setFeedbackNote(order.feedback.note);
                    setFeedbackImage(null);
                    setFeedbackImages([]);
                    setIsEditingFeedback(true);
                    setOpenFeedbackDialog(true);
                  }}
                >
                  ✏️ تعديل الفيدباك
                </Button>
      </Box>
    )}
  </Box>
)}


              <Box display="flex" flexDirection="column" gap={1}>
                {(() => {
                  const historyList = [...(order.history || [])].sort((a, b) => (b.timestamp?.toMillis() || 0) - (a.timestamp?.toMillis() || 0));
                  const validTimes = historyList.map((h) => h.timestamp?.toMillis() || 0).filter((t) => t > 0);
                  // ✅ نعرض "بواسطة" فقط لأول مرحلة (إرسال الطلب) - أقدم عنصر
                  // بالسجل زمنياً - وليس لبقية المراحل، بطلب المستخدم صراحة
                  const earliestTime = validTimes.length ? Math.min(...validTimes) : null;
                  return historyList.map((h, idx) => {
                  const ts = h.timestamp?.toDate();
                  const timestamp = ts ? `${ts.getFullYear()}-${String(ts.getMonth() + 1).padStart(2, "0")}-${String(ts.getDate()).padStart(2, "0")} ${String(ts.getHours()).padStart(2, "0")}:${String(ts.getMinutes()).padStart(2, "0")}` : "—";
                  const isFirstStage = earliestTime !== null && (h.timestamp?.toMillis() || 0) === earliestTime;
                  return (
                    <Paper key={idx} sx={{ p: 1.5, backgroundColor: "#f9f9f9" }}>
<Typography variant="body2"><strong>الحالة:</strong> {renameStatus(h.status, order)}</Typography>
                      {isFirstStage && (
                        <Typography variant="body2"><strong>بواسطة:</strong> {getDisplayName(h.by || h.updatedBy || "غير معروف")}</Typography>
                      )}
                      <Typography variant="body2"><strong>الوقت:</strong> {timestamp}</Typography>
                    </Paper>
                  );
                  });
                })()}
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      })}

      {/* البوب أب لتعديل الطلب */}
      <Dialog open={!!editingOrder} onClose={() => setEditingOrder(null)} fullWidth>
        <DialogTitle>تعديل الطلب</DialogTitle>
        <DialogContent>
          <TextField
            label="اسم الزبون"
            fullWidth
            margin="normal"
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
          />
          <TextField
            label="السعر"
            fullWidth
            margin="normal"
            type="number"
            value={editPrice}
            onChange={(e) => setEditPrice(e.target.value)}
          />
          <TextField
            label="الملاحظات"
            fullWidth
            margin="normal"
            multiline
            rows={3}
            value={editNote}
            onChange={(e) => setEditNote(e.target.value)}
          />
           {/* 🖼️ الصور المرفوعة سابقًا */}
                    {existingFeedbackImages.length > 0 && (
                      <Box mt={2}>
                        <Typography fontWeight="bold">
                          📷 صور الفيدباك الحالية:
                        </Typography>
                    
                        <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
                          {existingFeedbackImages.map((url, index) => (
                            <Box key={index} position="relative">
                              <img
                                src={url}
                                alt="feedback"
                                style={{
                                  width: 90,
                                  height: 90,
                                  objectFit: "cover",
                                  borderRadius: 8,
                                  border: "1px solid #ccc",
                                  cursor: "pointer",
                                }}
                                onClick={() => setPreviewFile({ url })}
                              />
                    
                              {/* ❌ زر حذف الصورة */}
                              <Button
                                size="small"
                                color="error"
                                sx={{
                                  position: "absolute",
                                  top: -6,
                                  right: -6,
                                  minWidth: 24,
                                  height: 24,
                                  borderRadius: "50%",
                                  padding: 0,
                                }}
                                onClick={() =>
                                  setExistingFeedbackImages(
                                    existingFeedbackImages.filter((_, i) => i !== index)
                                  )
                                }
                              >
                                ✕
                              </Button>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    )}
                    
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditingOrder(null)}>إلغاء</Button>
          <Button
  variant="contained"
  onClick={async () => {
    setLoading(true);
    await handleUpdate();
    setLoading(false);
  }}
>
  {loading ? "⏳ جاري الحفظ..." : "حفظ التعديلات"}
</Button>

        </DialogActions>
      </Dialog>
      <Dialog open={openFeedbackDialog} onClose={() => setOpenFeedbackDialog(false)}>
<DialogTitle>
  {isEditingFeedback
    ? "✏️ تعديل فيدباك الزبون"
    : "📩 إضافة فيدباك الزبون"}
</DialogTitle>
  <DialogContent>
    <Box display="flex" flexDirection="column" gap={2} mt={1}>
      <Typography fontWeight="bold">اختر نوع الفيدباك:</Typography>
      <Stack direction="row" spacing={2}>
        <Button
          variant={feedbackType === "ايجابي" ? "contained" : "outlined"}
          color="success"
          onClick={() => setFeedbackType("ايجابي")}
        >
          👍 إيجابي
        </Button>
        <Button
          variant={feedbackType === "سلبي" ? "contained" : "outlined"}
          color="error"
          onClick={() => setFeedbackType("سلبي")}
        >
          👎 سلبي
        </Button>
      </Stack>

      {/* إظهار الحقول فقط بعد اختيار النوع */}
      {feedbackType && (
        <>
          <TextField
            label="ملاحظات الزبون"
            multiline
            fullWidth
            rows={3}
            value={feedbackNote}
            onChange={(e) => setFeedbackNote(e.target.value)}
          />

          <Button
            variant="outlined"
            component="label"
          >
            📤 رفع صورة
          <input
  type="file"
  accept="image/*"
  multiple
  hidden
  onChange={(e) => {
    const files = [...feedbackImages, ...Array.from(e.target.files)];
    e.target.value = "";
    setFeedbackImage(files[0] || null); // يحافظ على القديم
    setFeedbackImages(files);           // الجديد
  }}
/>

          </Button>

          <UploadPreview
            files={feedbackImages}
            onChange={(list) => {
              setFeedbackImages(list);
              setFeedbackImage(list[0] || null);
            }}
          />
        </>
      )}
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenFeedbackDialog(false)}>إلغاء</Button>
    {!feedbackImage && currentFeedbackOrder?.feedback?.image && (
  <Box mt={2}>
    <Typography fontWeight="bold" fontSize={14}>الصورة المرفوعة سابقاً:</Typography>
    <img
      src={currentFeedbackOrder.feedback.image}
      alt="feedback"
      style={{ maxWidth: "100%", maxHeight: 250, borderRadius: 8 }}
    />
  </Box>
)}

   <Button
  variant="contained"
  onClick={handleSubmitFeedback}
  disabled={
    savingFeedback ||
    !feedbackType ||
    !feedbackNote ||
    (feedbackType === "سلبي" &&
      !feedbackImage &&
      feedbackImages.length === 0)
  }
>
  {savingFeedback ? "⏳ جاري الحفظ..." : "حفظ الفيدباك"}
</Button>

  </DialogActions>
</Dialog>


{/* 📷 Dialog رفع صور التركيب */}
<Dialog
  open={openInstallationDialog}
  onClose={() => setOpenInstallationDialog(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>📷 رفع صور التركيب</DialogTitle>

  <DialogContent>
    <Typography sx={{ mb: 2 }}>
      يرجى رفع صور أو فيديو تركيب اللوحة
    </Typography>

    <Button variant="outlined" component="label">
      اختيار ملفات
      <input
        type="file"
        accept="image/*,video/*"
        multiple
        hidden
        onChange={(e) => appendPickedFiles(e, setInstallationFiles)}
      />
    </Button>

    <Typography sx={{ mt: 1 }}>
      {installationFiles.length} ملف مختار
    </Typography>
    <Typography sx={{ mt: 0.5, fontSize: 13, color: "gray" }}>
  📷 صور: {installationFiles.filter(f => f.type.startsWith("image")).length}
  {" | "}
  🎥 فيديو: {installationFiles.filter(f => f.type.startsWith("video")).length}
</Typography>
    <UploadPreview files={installationFiles} onChange={setInstallationFiles} />

  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenInstallationDialog(false)}>
      إلغاء
    </Button>

   <Button
  variant="contained"
  disabled={installationFiles.length === 0 || uploadingInstallation}
  onClick={handleUploadInstallation}
>
  {uploadingInstallation ? "⏳ جاري الرفع..." : "حفظ"}
</Button>

  </DialogActions>
</Dialog>
{/* 🔍 Dialog معاينة صورة التركيب */}
<Dialog
  open={!!previewFile}
  onClose={() => setPreviewFile(null)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>📷 معاينة الصورة</DialogTitle>
  <DialogContent
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {previewFile && (
      <img
        src={previewFile.url}
        alt="preview"
        style={{
          maxWidth: "100%",
          maxHeight: "80vh",
          objectFit: "contain",
        }}
      />
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setPreviewFile(null)}>إغلاق</Button>
  </DialogActions>
</Dialog>

    </Container>
  );
};

export default SaraDashboard;
